import React from "react";

export default function FuelBar({ pct = 0 }) {
  const color =
    pct < 25 ? "var(--status-red)" :
    pct < 50 ? "var(--status-amber)" :
    "var(--status-green)";
  return (
    <div className="flex items-center gap-2">
      <div className="fuel-bar flex-1">
        <div style={{ width: `${pct}%`, background: color }} />
      </div>
      <span className="font-mono text-[11px]" style={{ color: "var(--slate-500)" }}>
        {pct}%
      </span>
    </div>
  );
}
